<template>
  <CoinWizard />
</template>

<script setup>
import CoinWizard from './Purchase/CoinWizard.vue'
</script>

<style scoped>
/* Styles are now in the individual components */
</style>
